import { toast } from 'react-toastify'
import {
  getAllNotes,
  // getAllPolicies,
  getAllSCRPoliciesAgreements,
  getAllRoles,
  getAllTrainigRecordsCategoriesSCR,
  getSCRData,
  getSCRDataSingleRecord,
  getSchoolAllPolicies,
  getAllSafeguardingRecordsCategoriesSCR,
  // getAllPolicyRecordsCategoriesSCR,
  // getAllPolicies,
} from '../../api/admin/scr'
import {
  getPolicyType,
  policiesAgreement,
  policiesAgreementResponse,
  // policyCategoriesResponse,
  // policyCategoriesResponseObj,
  policyResponse2,
  policyResponseSCR,
  Role,
  RolesDataResponse,
  safeguardingCategoriesResponse,
  safeguardingCategoriesResponseObj,
  traningCategoriesResponse,
  traningCategoriesResponseObj,
} from '../../utils/types'
import { getAllPublishedPolicies } from '../../api/candidate/policies'
export type Comment = {
  comment: string
  commentId: string
  'comments.createdAt': string
  createdBy: string
  firstName: string
}
interface TrainingRecord {
  userId: string
  trainingRecordCategoryId: string
  schoolId: string
  certificateNumber: string
  date: string
  reviewDate: string
  verifiedBy: string
  verificationDate: string
  riskAssessmentStatus: string
  duration: string
  certificate: string
  riskDocument: string
  comments?: Comment[]
}

interface Safeguarding {
  safeguardingRecordCategoryId: string
  isRejected: boolean
  verifiedBy: string
  verificationDate: string
  riskAssessmentStatus: string
  duration: string
  issueDate: string
  expiryDate: string
  riskDocument: string
  documentType: string
  documentNo: string
  document: string
}

interface Emlployment {
  id: string
  userId: string
  jobTitle: string
  department: string
  startDate: string
  endDate: string
  workStatus: string
  createdAt: string
  updatedAt: string
}

interface policies {
  policyId: string
  policyDocument: string
  title: string
}
interface policyAgreement {
  policyId: string
  createdAt: string
}

export interface User {
  profileImageUrl: string | undefined
  id: string
  userId: string
  schoolId: string
  roleId: string
  updatedAt: string
  createdAt: string
  userName: string
  email: string
  status: string
  schoolName: string
  role: string
  EmploymentDetails: Emlployment[]
  DBScertificateNumber: string | null
  DBSissueDate: string | null
  DBSreviewDate: string | null
  DBSverifiedBy: string | null
  DBSverificationDate: string | null
  DBSriskAssessmentStatus: string | null
  DBSduration: string | null
  DBScertificate: string | null
  RTW_evidenceType: string | null
  RTW_verifiedBy: string | null
  RTW_verificationDate: string | null
  RTW_certificate: string | null
  RTW_expiryDate: string | null
  title: string | null
  firstName: string | null
  lastName: string | null
  dateOfBirth: string | null
  gender: string | null
  ethnicity: string | null
  nationality: string | null
  disability: string | null
  businessContactNumber: string | null
  extensionNumber: string | null
  personalContactNumber: string | null
  businessEmail: string | null
  personalEmail: string | null
  addressLineOne: string | null
  addressLineTwo: string | null
  town: string | null
  country: string | null
  postCode: string | null
  e_contact_firstName: string | null
  e_contact_lastName: string | null
  e_contact_contactNumber: string | null
  e_contact_relationship: string | null
  e_contact_addressLineOne: string | null
  e_contact_addressLineTwo: string | null
  e_contact_town: string | null
  e_contact_country: string | null
  e_contact_postCode: string | null
  trainingRecords: TrainingRecord[]
  safeguardingRecords: Safeguarding[]
  Policies: policies[]
  userPolicyAgreements: policyAgreement[]

  safeguardingRecordCategory: {
    id: string
    title: string
    expiryDate: boolean
    issueDate: boolean
    referenceUrl: string
    riskAssessment: boolean
  }[]

  profileImage: string
  trainingRecordCategory: {
    id: string
    title: string
  }[]

  ReferenceChecks: {
    id: string
    userId: string
    verifiedBy: string
    verificationDate: string
    type: string
    certificate: string
    createdAt: string
    updatedAt: string
  }[] // You can define a type for ReferenceCheck if available
  Identifications: {
    id: string
    userId: string
    verifiedBy: string
    verificationDate: string
    type: string
    evidenceType: string
    certificate: string
    createdAt: string
    updatedAt: string
  }[] // You can define a type for Identification if available
}

// Usage

export interface UserDataCountObj {
  data: User[]
  count: string
}

export interface UserResponse {
  status: string
  data: UserDataCountObj
  // count: string
}
export interface UserResponseObj {
  status: string
  data: User
}

interface notes {
  id: string
  noId: number
  userId: string
  createdBy: string
  updatedBy: string
  detail: string
  title: string
  createdAt: string
  updatedAt: string
  createdByName: string
  updatedByName: string
}

interface notesResponse {
  status: string
  data: notes[]
}

export const getScrRecord = async (
  data: string[],
  currentPage: number,
  sortBy: string,
  sortOrderValue: string,
  activeTab: string
): Promise<UserDataCountObj> => {
  const response = (await getSCRData(
    data,
    currentPage,
    sortBy,
    sortOrderValue,
    activeTab
  )) as UserResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getScrSingleRecord = async (
  data: string,
  id: string
): Promise<User> => {
  const response = (await getSCRDataSingleRecord(data, id)) as UserResponseObj

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getTraningCategoriesForSCR =
  async (): Promise<traningCategoriesResponseObj> => {
    const response =
      (await getAllTrainigRecordsCategoriesSCR()) as traningCategoriesResponse

    if (response?.status != 'successful') {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
    return response?.data
  }

export const getSafeguardingCategoriesForSCR =
  async (): Promise<safeguardingCategoriesResponseObj> => {
    const response =
      (await getAllSafeguardingRecordsCategoriesSCR()) as safeguardingCategoriesResponse

    if (response?.status != 'successful') {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
    return response?.data
  }

// export const getPolicy = async (): Promise<getPolicyType[]> => {
//   const response =
//     (await getAllPolicyRecordsCategoriesSCR()) as policyResponseSCR

//   if (response?.status != 'successful') {
//     toast.error('Network Error.', {
//       position: 'top-right',
//     })
//   }
//   return response?.data
// }

export const getPolicy = async (): Promise<policyResponse2> => {
  const response = (await getAllPublishedPolicies()) as policyResponse2

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response
}

export const getSCRroles = async (): Promise<Role[]> => {
  const response = (await getAllRoles()) as RolesDataResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getPolicyData = async (sId: string): Promise<getPolicyType[]> => {
  const response = (await getSchoolAllPolicies(sId)) as policyResponseSCR

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getPolicyAgreement = async (
  school: string,
  userId: string | undefined
): Promise<policiesAgreement[]> => {
  const response = (await getAllSCRPoliciesAgreements(
    school,
    userId
  )) as policiesAgreementResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getNotes = async (
  id: string,
  schoolId: string
): Promise<notes[]> => {
  const response = (await getAllNotes(id, schoolId)) as notesResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}
